export default __webpack_public_path__ + "static/media/Form102Certificate.24836f62.png";